// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"8e4d2e785335146ff853","678":"b670428f59677668deb0","883":"bbd1550dc6c03bf14527"}[chunkId] + ".js";
};